var Purchasable;

Purchasable = function(self) {
  self.add_to_cart = (function(_this) {
    return function(item) {
      return $.post_json('/library/cart/' + self.id + '.json?_method=put', function(data) {
        return self.in_cart(true);
      });
    };
  })(this);
  Observable(self, 'in_cart', false);
  return self;
};

//# sourceMappingURL=purchasable.js.map
